import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { DarkModeProvider } from './contexts/DarkModeContext';
import { FontSizeProvider } from './contexts/FontSizeContext';
import Layout from './components/layout/Layout';
import Login from './components/auth/Login';
import Calls from './pages/Calls';
import Customers from './pages/Customers';
import CustomerDetail from './pages/CustomerDetail';
import Orders from './pages/Orders';
import ServiceCalls from './pages/ServiceCalls';
import Sales from './pages/Sales';
import Documents from './pages/Documents';
import Settings from './pages/Settings';
import FieldMode from './pages/FieldMode';

function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading, isAdmin } = useAuth();
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-50 dark:bg-gray-900">
        <div className="animate-spin h-8 w-8 border-2 border-primary-500 border-t-transparent rounded-full" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && !isAdmin) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <DarkModeProvider>
        <FontSizeProvider>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/calls" replace />} />
              <Route path="calls" element={<Calls />} />
              <Route path="customers" element={<Customers />} />
              <Route path="customers/:id" element={<CustomerDetail />} />
              <Route path="orders" element={<Orders />} />
              <Route path="service-calls" element={<ServiceCalls />} />
              <Route path="sales" element={<Sales />} />
              <Route path="documents" element={<Documents />} />
              <Route path="field" element={<FieldMode />} />
              <Route path="settings" element={
                <ProtectedRoute adminOnly>
                  <Settings />
                </ProtectedRoute>
              } />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
        </FontSizeProvider>
      </DarkModeProvider>
    </BrowserRouter>
  );
}

export default App;
